import styled from 'styled-components'
import themeAsseticonVideoFreePng from '@theme/icon-video/free.png'

export const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 0.87rem;
  height: 0.61rem;
  line-height: 0.56rem;
  background-image: url('${themeAsseticonVideoFreePng}');
  background-size: 100% 100%;
`
